import $ from 'jquery'
import ExcelModal from '@/views/parametres/import-excel-modal'
import ManageDureeBon from '@/views/parametres/configs/param-consultations/manage-duree-bon'

export default {
    name: 'param-consultations',
    components: {
        ExcelModal, ManageDureeBon
    },
    props: [],
    data() {
        return {
            fields: [
				'prestations',  { key: 'duree_bon', label: 'Durée de bon' }, 
                { key: 'actions', label: 'Action.s' }
			],
			filter_consult_gen: "",
			perPage: 20,
			currentPage: 1,

            consul_loading: true,
            consul_empty: true,

            c_prestation: {
				type_consultation_id: 0,
                categorie_id: 2,
				libelle: '',
                duree_bon: ""
			},
            is_edit: false,

            save_loading: false,
            modal_title: 'Nouvelle prestation',
            exist_error: false,

            consult_to_be_deleted: {
				id: 0,
				libelle: ''
			},
			is_confirm: false,
			del_loading: false,

            is_printing: false,
            filename: '',

            type_admission: '',
            designation: '',
            emit_action: '',
            modal_toggler: true,

            consultation_fields: {
                'Catégorie': 'categorie',
                'Libellé': 'libelle',
                'Moment de consultation': 'moment_consultation',
                'Prix': 'prix',
            },

            consultation_data: [],
            consultation_filename: 'Liste_Consultations.xls',
            state_toggler: 0,

            c_loading_percentage: 0,
            can_view_percentage: false,
            c_refresh_timeout_id: null,
            countdown_seconds_left: 0,
            countdown_interval_id: null,
        }
    },

    computed: {
        liste_all_type_consultations() {
            return this.$store.getters["liste_all_type_consultations"];
        },

        consult_gen_rows() {
            return this.liste_all_type_consultations.length;
        },

        list_consultations_with_tarif() {
            return this.$store.getters["list_consultations_with_tarif"];
        }
    },

    beforeDestroy() {
        if (this.c_refresh_timeout_id) {
            clearTimeout(this.c_refresh_timeout_id)
            this.c_refresh_timeout_id = null
        }

        if (this.countdown_interval_id) {
            clearInterval(this.countdown_interval_id)
            this.countdown_interval_id = null
        }
    },

    mounted() {
        // Consultation généraliste
        this.fetchListeConsultations()
		
        var d = new Date()
        var tmpstamp = d.getHours()+''+d.getMinutes()+''+d.getFullYear()

        this.filename = 'Liste_de_consultations_'+tmpstamp

        this.$store.dispatch("getTarifsConsultations").then(() => {
            this.list_consultations_with_tarif.forEach(consultation => {
                this.consultation_data.push({
                    'categorie': (consultation.type_consultation.categorie_consultation_id == 1)?'Généraliste':'Spécialiste', 
                    'libelle' : consultation.type_consultation.nom,
                    'moment_consultation': consultation.moment_consultation.denomination,
                    'prix' : (consultation.prix > 0)?consultation.prix:''
                })
            });
        })
    },

    methods: {
        importExcelFile(type_admission, designation) {
            this.type_admission = type_admission
            this.designation = designation
            this.modal_toggler = (this.modal_toggler)?false:true

            this.emit_action = 'emitListConsultation'
            setTimeout(() => {
                $('.excel-modal-'+type_admission).modal('show')
            }, 200);
        },

        countdownLoad() {
            const TOTAL_SECONDS = 12 * 60

            if (this.countdown_interval_id) {
                clearInterval(this.countdown_interval_id)
                this.countdown_interval_id = null
            }

            this.countdown_seconds_left = TOTAL_SECONDS
            // Initialize percentage based on full remaining time
            this.c_loading_percentage = 100

            this.countdown_interval_id = setInterval(() => {
                if (this.countdown_seconds_left > 0) {
                    this.countdown_seconds_left--
                    // Update loading percentage according to remaining time
                    this.c_loading_percentage = (this.countdown_seconds_left / TOTAL_SECONDS) * 100
                } else {
                    clearInterval(this.countdown_interval_id)
                    this.countdown_interval_id = null
                    this.c_loading_percentage = 0
                }
            }, 1000)
        },

		refreshListeConsultations() {
            this.consul_loading = true
            this.can_view_percentage = true
            if (this.c_refresh_timeout_id) {
                clearTimeout(this.c_refresh_timeout_id)
                this.c_refresh_timeout_id = null
            }

            if (this.liste_all_type_consultations.length > 0) {
                this.countdown_seconds_left = 0
            }

            if (this.countdown_seconds_left == 0 ) {
                this.can_view_percentage = false
                this.fetchListeConsultations()
                return
            }

            // Re-fetch then retry after 5s until counts match
            this.fetchListeConsultations()
            this.c_refresh_timeout_id = setTimeout(() => {
                this.refreshListeConsultations()
            }, 5000)
        },

		loadEmitAction() {
            this.countdownLoad()
            this.refreshListeConsultations()
        },

        fetchListeConsultations() {
			this.consul_loading = true

			this.$store.dispatch("getListeTypeConsultations").then(() => {
                if(this.liste_all_type_consultations.length > 0) {
                    this.consul_empty = false
                } else {
                    this.consul_empty = true
                }

                if (this.can_view_percentage) {
                    if (this.countdown_seconds_left == 0) {
                        this.consul_loading = false
                    }
                } else {
                    this.consul_loading = false
                }
            });
		},

        /**
		 * Ajouter un type de prestation
		 */
		addPrestation () {
			this.is_edit = false
            this.modal_title = 'Nouvelle prestation'

			this.c_prestation = {
				type_consultation_id: 0,
                categorie_id: 2,
				libelle: '',
                duree_bon: '',
                unite_duree: 'jours'
			}
		},

        edit(data) {
            this.is_edit = true

            this.c_prestation = {
                type_consultation_id: data.id,
                categorie_id: data.categorie_id,
                libelle: data.nom,
                duree_bon: data.duree_bon,
                unite_duree: data.unite_duree
            }
            this.modal_title = data.nom
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

		/**
		 * Selectionne la prestation de consultation à supprimer
		 * @param {*} data 
		 */
		remove(data) {
			this.consult_to_be_deleted = {
                id: data.id,
                libelle: data.nom,
            }
		},

		/**
		 * Retirer un examen de la liste de demande
		 */
        supprimer() {
            this.del_loading = true;

            let confirm = document.getElementById('cfrm-del');
            let err = 0

            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                err++;
                this.del_loading = false;
            }

            if (err == 0) {
                this.$store.dispatch('deleteTypeConsultation', this.consult_to_be_deleted).then((response) => {
                    
                    if (response > 0) {
                        this.successMsg('Type de consultation supprimé avec succès')
                    }
                    this.del_loading = false;
                    this.is_confirm = false

					this.fetchListeConsultations(this.del_categorie_consultation);
					this.$refs.del_modal.click()

                    
                })
            }
        },

        /**
         * Enregistrer / Modifier une prestation
         */
        async submitPrestation() {
            const isValid = await this.$refs.consult_form.validate();

            if (!isValid) {
                return;
            }

            this.save_loading = true
            
            this.c_prestation.duree_bon = parseInt(this.c_prestation.duree_bon)
            
            this.$store.dispatch("saveTypeConsultation", this.c_prestation).then((response) => {
                this.save_loading = false

                if (response.success) {
                    this.successMsg('Opération effectuée avec succès')
                    this.fetchListeConsultations()

                    this.$refs.consult_form.reset()
                    this.$refs.modal_prestation.click()
                } else {
                    if (response.code == 409) {
                        this.exist_error = true
                    } else if (response.code == 500) {
                        this.errorToast('Merci de renseigner le nom du type de consultation')
                    } else if (response.code == 501) {
                        this.errorToast('Une erreur s\'est produite ! Merci de réessayer plustard')
                    }
                }
            })
        },

        clearError() {
            this.exist_error = false
        },

        successMsg: function(message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        },

        handleBeforeGenerateConsultation() {
            let d = new Date()
            this.consultation_filename = 'Liste_Consultations_'+d.getMilliseconds()+'.xls'
            this.is_exporting = true
        },

        setDureeBon() {
            this.state_toggler = (this.state_toggler == 0)?1:0

            $('.manage-duree-bon').modal('show')
        },

        printConsultation() {
            const data = {
                data_type: 'consultations',
                prestations: this.liste_all_type_consultations
            }
            this.$emit('emitTriggerPrint', data)
        }
    }
}


